<template>
  <div class="PermissionGroupComponent">

    <b-form-group :label="lang.label_Groups" label-for="tags-with-dropdown">
      <b-form-tags id="tags-with-dropdown" v-model="value" no-outer-focus class="mb-2" :disabled="isDisabled">


        <ul v-if="groups.length > 0" class="list-inline d-inline-block mb-2">
          <li v-for="group in groups" :key="group.groupId" class="list-inline-item">
            <b-form-tag @remove="removeGroup(group)" :title="group.groupName"
              :no-remove="(group.groupName == 'All') && (defaultSettings.parent == 'user')"
              :disabled="group.groupName == 'Admins'" :variant="group.groupName != 'Admins'?'orange':'danger'">{{
              group.groupName }}</b-form-tag>
          </li>

        </ul>
        
        <b-dropdown size="sm" variant="outline-secondary" block menu-class="w-100">

          <b-dropdown-form @submit.stop.prevent="() => { }">
            <b-form-group :label="lang.label_Search" label-for="tag-search-input" label-cols-md="auto" class="mb-0"
              label-size="sm" :description="searchDesc" :disabled="disabled">
              <b-form-input v-model="search" id="tag-search-input" type="search" size="sm"
                autocomplete="off"></b-form-input>
            </b-form-group>
          </b-dropdown-form>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item-button v-for="option in availableGroups" :key="option.groupId" @click="addGroup(option)">
            {{ option.groupName }}
          </b-dropdown-item-button>
          <b-dropdown-text v-if="availableGroups.length === 0">
            {{ lang.infotext_1 }}
          </b-dropdown-text>
        </b-dropdown>


      </b-form-tags>
    </b-form-group>

    <br>
  </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

export default {
  name: 'PermissionGroupComponent',
  props:{
    lang: Object,
    defaultSettings: Object,
    isDisabled: Boolean
  },
  components: {


  },
  data () {
      return {
          options: [],
          search: '',
          value: [],
          groups: [],
          disabled: true,
          defaultList: []
      }
  },
  computed: {
    permissionsCategory() {

      
      

      return [-123130]//this.data;
    },
    criteria() {
            
       return this.search.trim().toLowerCase()
    },
    availableGroups() {
      const criteria = this.criteria;
        
      let options = this.options.filter(opt => this.value.indexOf(opt.groupName) === -1)
      
      if (criteria) {
          
          return options.filter(opt => opt.groupName.toLowerCase().indexOf(criteria) > -1);
      }
            
      return options;
    },
    searchDesc() {
      
        if (this.criteria && this.availableGroups.length === 0) {
          return this.lang.infotext_2;
        }
        return ''
    }

  },
  created() {
    this.$store.commit("SETPERMISSIONGROUP", []);
    this.getGroups();
    //this.options = []

  },
  watch: {
    groups: {
      handler: function (newVal) {
        
        this.$store.commit("SETPERMISSIONGROUP", newVal);
      },
      deep: true
    },
    defaultSettings: {
      handler: function (newVal, oldVal) {
        
        
        if (!this.compareObjects(newVal, oldVal)){
          this.main();
        }
        
       
        
        
        
      },
      deep: true
      
    },
  },
  
  methods: {
    compareObjects(obj1, obj2) {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (const key of keys1) {
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }

      return true;
    },
    main() {
      
      if (this.defaultSettings == undefined) {
        return;
      }
      if (this.defaultSettings.groups == undefined) {
        return;
      }
      
      if (this.defaultSettings.groups.length > 0) {

        this.removeAll();
        
        for (let i = 0, lei = this.defaultSettings.groups.length; i < lei; i++){
          for (let j = 0, lej = this.options.length; j < lej; j++) {

            if (this.defaultSettings.isId) {
              
              if (this.defaultSettings.groups[i] == this.options[j].groupId) {
                this.addGroup(this.options[j]);
                break;
              }
            } else {
              if (this.defaultSettings.groups[i] == this.options[j].groupName) {
                this.addGroup(this.options[j]);
                break;
              }
            }
            
          }
          

        }
        

      }
    },
    getGroups() {

      let _vue = this;
      _vue.defaultList = [];

      this.$store.dispatch("u_getGroups")
        .then(function (result) {

          console.log(result.data)

          if (result.status == "OK") {

            if (result.data != null) {

              //_vue.defaultList = result.data;
              for (let i = 0, lei = result.data.length; i < lei; i++){
                _vue.defaultList.push(result.data[i]);
              }
              
              _vue.options = result.data;
              
              _vue.main();

            }
          }




        })
    },
    addGroup(item) {
      
      if (!this.groups.includes(item)) {
          
        this.groups.push(item);

        
        for (let j = 0, lej = this.options.length; j < lej; j++) {

          if (item.groupName == this.options[j].groupName) {

            this.options.splice(j, 1);
            break;
          }
        }
        
        
      }
    

      this.search = '';
    },
    
    removeGroup(item) {
      
      
      for (let j = 0, lej = this.groups.length; j < lej; j++) {

        if (item.groupId == this.groups[j].groupId) {

          this.groups.splice(j, 1);
          break;
        }
      }

      if (!this.options.includes(item)) {
        this.options.push(item);
      }
        
    },
    removeAll() {
      
      this.groups = [];
      this.options = [];
      for (let j = 0, lej = this.defaultList.length; j < lej; j++) {
        this.options.push(this.defaultList[j]); 
      }
       
    }    


  }
}
</script>

<style scoped>
    .PermissionGroupComponent{
        
    }

</style>


// WEBPACK FOOTER //
// src/components/shared/PermissionGroupComponent.vue